

<template>
  <!-- News Page Start -->
  <section class="news_page_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_1.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Do You Think About Cheese Pizza Recipes?</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_2.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Chicken Strips With New Ingridents Made.</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_3.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Hot Chessyraw Pasta Make Creator Fact.</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_1.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Do You Think About Cheese Pizza Recipes?</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_1.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Do You Think About Cheese Pizza Recipes?</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="blog_item">
                <div class="blog_image">
                  <a href="#">
                    <img src="../../assets/img/blog_2.jpg" alt="blog" />
                  </a>
                  <div class="post_date">
                    <div class="date">13</div>
                    <div class="month">Feb</div>
                  </div>
                </div>
                <div class="blog_text">
                  <div class="blog-meta">
                    <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  </div>
                  <h3>
                    <a href="#">Chicken Strips With New Ingridents Made.</a>
                  </h3>
                  <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut enim ad minima, quis nostrum onem</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="pagination-box-row">
                <p>Page 1 of 6</p>
                <ul class="pagination">
                  <li><a href="#">1</a></li>
                  <li class="active"><a href="#">2</a></li>
                  <li><a href="#">3</a></li>
                  <li>...</li>
                  <li><a href="#">6</a></li>
                  <li><a href="#"><i class="fa fa-angle-double-right"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="sidebar-widget">
            <div class="single-sidebar">
              <form>
                <input type="search" placeholder="Search..." />
                <button type="submit"><i class="fa fa-search"></i></button>
              </form>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Categories</h3>
              <ul class="category">
                <li><a href="#">Chicken</a></li>
                <li><a href="#">Donuts</a></li>
                <li><a href="#">Drinks</a></li>
                <li><a href="#">Fries</a></li>
                <li><a href="#">Pizza</a></li>
                <li><a href="#">Sandwich</a></li>
                <li><a href="#">Uncategorized</a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Tags</h3>
              <ul class="Tags-catagory">
                <li><a href="#">Chicken</a></li>
                <li><a href="#">Donuts</a></li>
                <li><a href="#">Drinks</a></li>
                <li><a href="#">Fries</a></li>
                <li><a href="#">Pizza</a></li>
                <li><a href="#">Sandwich</a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Popular Post</h3>
              <ul class="recent-blog">
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s1.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s2.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s3.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s1.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Archive</h3>
              <ul class="category">
                <li><a href="#">August 2018 <span>(29)</span></a></li>
                <li><a href="#">July 2018 <span>(12)</span></a></li>
                <li><a href="#">June 2018 <span>(22)</span></a></li>
                <li><a href="#">May 2018 <span>(11)</span></a></li>
                <li><a href="#">April 2018 <span>(12)</span></a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <a href="javascript:;">
                <img src="../../assets/img/promo_add.jpg" alt="img" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- News Page End -->
</template>
<script>
export default {
  name: 'NewsPageArea'
}
</script>



// WEBPACK FOOTER //
// src/components/news/NewsPageArea.vue